import { css } from '@emotion/react';
import { COLOR_PALETTE, Flex, Spoiler } from '@inflearn/ds-react';
import { rem } from '@mantine/core';
import { isNil } from 'lodash-es';
import { type ReactNode, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

const TEXT_HIDE = '숨기기';
const TEXT_SHOW = '더보기';

export const ReadOnlyIntroduce = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleChange = (changed: boolean) => {
    setIsExpanded(changed);
  };

  const spoilerButtonRef = useCallback((spoilerButton: HTMLButtonElement | null) => {
    if (isNil(spoilerButton)) {
      return;
    }

    const handleChangeSpoiler = () => {
      const changed = spoilerButton.innerHTML === t(TEXT_SHOW);
      handleChange(changed);
    };

    spoilerButton.addEventListener('click', handleChangeSpoiler);

    return () => {
      spoilerButton.removeEventListener('click', handleChangeSpoiler);
    };
  }, []);

  return (
    <Flex direction="column" w="100%">
      <Spoiler
        id="profile-introduce"
        w="100%"
        maxHeight={240}
        hideLabel={t(TEXT_HIDE)}
        showLabel={t(TEXT_SHOW)}
        controlRef={spoilerButtonRef}
        css={styleIntroduce(isExpanded)}
      >
        {children}
      </Spoiler>
    </Flex>
  );
};

const styleIntroduce = (isExpanded: boolean) =>
  css({
    button: {
      marginTop: rem(16),
      color: COLOR_PALETTE.gray[6],
    },
    'button::after': {
      position: 'absolute',
      bottom: rem(40),
      left: 0,
      right: 0,
      display: isExpanded ? 'none' : 'block',
      content: '""',
      height: rem(60),
      background: `linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.99) 11.79%, rgba(255, 255, 255, 0.97) 21.38%, rgba(255, 255, 255, 0.93) 29.12%, rgba(255, 255, 255, 0.88) 35.34%, rgba(255, 255, 255, 0.82) 40.37%, rgba(255, 255, 255, 0.75) 44.56%, rgba(255, 255, 255, 0.67) 48.24%, rgba(255, 255, 255, 0.59) 51.76%, rgba(255, 255, 255, 0.50) 55.44%, rgba(255, 255, 255, 0.41) 59.63%, rgba(255, 255, 255, 0.33) 64.66%, rgba(255, 255, 255, 0.24) 70.88%, rgba(255, 255, 255, 0.15) 78.62%, rgba(255, 255, 255, 0.07) 88.21%, rgba(255, 255, 255, 0.00) 100%)`,
    },
  });
